module.exports = __webpack_public_path__ + "static/media/02_supermanha_mobile.b3a312f4.jpg";